export default function AppModule() {
  return (
    <section id="app" className="py-16 md:py-20 px-4 md:px-6 bg-background-900/50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-background-800/30 border border-background-700/20 rounded-2xl p-8 md:p-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex items-center gap-3 mb-6 justify-center lg:justify-start">
              <div className="w-1 h-7 bg-accent-500 rounded-full"></div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">移动观影</h2>
            </div>
            <p className="text-foreground-400 text-sm md:text-base leading-relaxed mb-3">
              下载777影院APP，随时随地享受<strong className="text-foreground-200">高清免费观影</strong>体验。支持离线缓存，通勤路上、旅途中也能畅快追剧。
            </p>
            <p className="text-foreground-500 text-sm leading-relaxed mb-6">
              适配iOS与Android系统，<strong className="text-accent-400">超清画质</strong>不妥协，<strong className="text-accent-400">极速播放</strong>零等待，给你掌心里的私人影院。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 bg-foreground-50 hover:bg-foreground-100 text-background-950 font-semibold rounded-full transition-all text-sm cursor-pointer"
              >
                <i className="ri-apple-fill text-lg"></i>
                iOS 下载
              </a>
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 bg-accent-500/20 hover:bg-accent-500/30 border border-accent-500/40 text-accent-400 font-semibold rounded-full transition-all text-sm cursor-pointer"
              >
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </a>
            </div>
          </div>
          <div className="flex-shrink-0 w-full max-w-sm">
            <div className="relative mx-auto w-48 md:w-56">
              <div className="absolute inset-0 bg-accent-500/15 rounded-3xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20movie%20streaming%20app%20interface%20with%20dark%20theme%2C%20showcasing%20film%20posters%20and%20play%20buttons%2C%20clean%20UI%20design%2C%20floating%20device%20on%20dark%20background%2C%20premium%20app%20presentation&width=500&height=1000&seq=app-mockup&orientation=portrait"
                alt="777影院APP界面"
                className="relative w-full object-contain"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}